import { ArrowUpRight } from "lucide-react";
import { useSceneActivity } from "./ui";

export function BrandMarquee() {
  const { ref, active } = useSceneActivity();
  return (
    <div
      ref={ref}
      className="brand-marquee"
      data-running={active}
      aria-hidden="true"
    >
      <div className="brand-marquee-track">
        {[0, 1].map((copy) => (
          <div className="brand-marquee-group" key={copy}>
            {["Precision.", "Speed.", "Elegance."].map((word, i) => (
              <span className={i === 1 ? "marquee-outline" : ""} key={word}>
                {word}
                <ArrowUpRight size={25} strokeWidth={1.2} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
